import { lazy } from 'react'

/**
 * Landings mounted on a subpath are loaded lazily so they are not shipped to
 * visitors of the root landing. The root landing itself is imported statically
 * in `App` to keep its CSS render-blocking in `index.html`.
 */
export const SmarcelLanding = lazy(async () => {
  const { SmarcelLanding: Landing } = await import('smarcel-core')

  return { default: Landing }
})
